import * as fb from '../../firebase'
//import * as firebase from 'firebase/app'

export default {
  namespaced: true,
  state: {
    params: {},
    goal:{}
  },

  /* ======================================================================= */
  mutations: {
    initGoalInfo(state, payload) {
      state.params = payload
    },

    saveGoalInfo(state, payload) {
      if (payload.key) {
        const key = payload.key;
        state.goal[key] = payload.data[key];
      }
      else if(payload.data){
        state.goal= payload.data;
      }
    },

    updateGoalProgress(state, payload) {
      state.params['progress'] = payload.progress
      state.goal['progress']=payload.progress
    }
  },

  /* ======================================================================= */
  actions: {
    //
    initGoalInfo({ commit }, payload) {
      commit('initGoalInfo', payload)
    },

    async saveGoalInfo({ state, dispatch, commit }, payload) {
      console.log('Payload:', payload)

      if (Object.keys(state.goal).length > 0) {
        dispatch('updateGoalInfo', payload)
        return;
      }
      
      console.log('About to save goal info')
      await fb.goalsCollection.doc(fb.auth.currentUser.uid).collection('goalsdetails').doc(payload.id).set(payload.data)
        .then(() => {
          commit('saveGoalInfo', payload)
          if (payload.data.progress) {
            dispatch('updateGoalProgress', payload)
          }
        })
        .catch(error => {
          console.log('Error creating new goal info:', error)
        })
    },

    async updateGoalInfo({dispatch, commit }, payload) {
      console.log('About to update goal info')

      await fb.goalsCollection.doc(fb.auth.currentUser.uid).collection('goalsdetails').doc(payload.id).update(payload.data)
        .then(() => {
          commit('saveGoalInfo', payload)

          if (payload.data.progress) {
            dispatch('updateGoalProgress', payload)
          }
        })
        .catch(error => {
          console.log('Error updating new goal info:', error)
        })
    },
    //
    async fetchGoalInfo({ commit }, payload) {
      var details={}
      await fb.goalsCollection.doc(fb.auth.currentUser.uid).collection('goalsdetails').doc(payload.id).get()
        .then((doc) => {
          if (doc.exists && doc.data()) {
            details = doc.data()
          }
          else {
            console.log('No goal match found')
          }
          commit('saveGoalInfo', { data: details })
        })
        .catch(error => {
          console.log('Error fetching goal info:', error)
        })
    },

    async updateGoalProgress({ commit }, payload) {
      console.log('Updating goal progress')
      const fieldpath=payload.term + '_term'+'.'+payload.id+'.progress'
      await fb.goalsCollection.doc(fb.auth.currentUser.uid).collection('goals').doc(payload.category).update({ [fieldpath]: payload.data.progress })
        .then(() => {
          commit('updateGoalProgress', {progress: payload.data.progress})
        })
        .catch(error => {
          console.log('Error updating goals:', error)
        });
 
    }

  },

  /* ======================================================================= */
  getters: {

  }
}